"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_um_role_client_js_1 = require("@synisys/idm-um-role-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var category_permission_expression_dto_1 = require("../model/api/category-permission-expression-dto");
var storage_service_1 = require("../../../../../shared/services/api/storage-service");
var idm_um_organization_client_js_1 = require("@synisys/idm-um-organization-client-js");
var operators_1 = require("rxjs/operators");
var Observable_1 = require("rxjs/Observable");
var WfPermissionsHelperService = /** @class */ (function () {
    function WfPermissionsHelperService(applicationPropertiesService, roleService, organizationService, permissionService, storageService) {
        this.applicationPropertiesService = applicationPropertiesService;
        this.roleService = roleService;
        this.organizationService = organizationService;
        this.permissionService = permissionService;
        this.storageService = storageService;
    }
    WfPermissionsHelperService.prototype.getRoles = function (roleIds) {
        return this.roleService.getByIds(roleIds);
    };
    WfPermissionsHelperService.prototype.getCategoryConditionalPermissions = function (category) {
        var _this = this;
        return this.permissionService.getCategoryPermissions().pipe(operators_1.map(function (value) { return value[-1]; }), operators_1.map(function (value) { return value.filter(function (permission) {
            return permission.categorySystemName === category && permission.isConditionalPermission && permission.sortId !== 999;
        }); }), operators_1.switchMap(function (conditionalPermissions) {
            var permissionKeys = conditionalPermissions.map(function (conditionalPermission) { return conditionalPermission.permissionKey; });
            if (permissionKeys && permissionKeys.length) {
                return _this.permissionService.getCategoryConditionalPermissionsExpressions(permissionKeys).pipe(operators_1.map(function (expressions) {
                    return conditionalPermissions.map(function (conditionalPermission) {
                        var permissionKey = conditionalPermission.permissionKey;
                        var name = conditionalPermission.name;
                        var expression = expressions[permissionKey];
                        return new category_permission_expression_dto_1.CategoryPermissionExpressionDto(permissionKey, expression, name);
                    });
                }));
            }
            return Observable_1.Observable.of([]);
        }));
    };
    WfPermissionsHelperService.prototype.createCategoryConditionalPermissions = function (categoryConditionalPermissionDtos) {
        return this.permissionService.createCategoryConditionalPermissions(categoryConditionalPermissionDtos);
    };
    WfPermissionsHelperService.prototype.updateCategoryConditionalPermissions = function (categoryConditionalPermissionDtos) {
        return this.permissionService.updateCategoryConditionalPermissions(categoryConditionalPermissionDtos);
    };
    WfPermissionsHelperService.prototype.updateOrganizationPermissions = function (organizationId, actionPermissionKey, wfProcessByAction) {
        var _this = this;
        var org$ = this.organizationService.getById(organizationId);
        var orgPermissionGroup$ = this.organizationService.getPermissionGroupGrantAll(organizationId);
        var orgActions$ = this.organizationService.getOrganizationActions(organizationId);
        var orgProcesses$ = this.organizationService.getOrganizationProcesses(organizationId);
        return Observable_1.Observable.zip(org$, orgPermissionGroup$, orgActions$, orgProcesses$).pipe(operators_1.switchMap(function (data) {
            var organization = data[0];
            var permissionGroupGrantAllDtos = data[1];
            var orgActions = data[2];
            var orgProcesses = data[3];
            var categoryPermissions = [];
            var workflowPermissionsDto = {
                actions: orgActions,
                processes: orgProcesses
            };
            actionPermissionKey.forEach(function (permissionKeys, actionId) {
                permissionKeys.forEach(function (permissionKey) {
                    var processId = wfProcessByAction.get(actionId);
                    // add to org category permissions to be available roles data security tab
                    categoryPermissions.push({
                        'permissionKey': permissionKey,
                        'permissions': {
                            'EDIT': true,
                            'VIEW': true,
                            'DELETE': false,
                            'ADD': null
                        }
                    });
                    // add to org workflow permissions to be available roles WF security tab
                    if (workflowPermissionsDto.processes) {
                        var processIndex = workflowPermissionsDto.processes.findIndex(function (value) { return value.id === processId; });
                        if (processIndex !== -1) {
                            if (workflowPermissionsDto.processes[processIndex].categoryPermissionKeys.indexOf(permissionKey) === -1) {
                                workflowPermissionsDto.processes[processIndex].categoryPermissionKeys.push(permissionKey);
                            }
                        }
                        else {
                            if (!workflowPermissionsDto.actions) {
                                workflowPermissionsDto.actions = new Map();
                            }
                            if (!workflowPermissionsDto.actions.has(processId)) {
                                workflowPermissionsDto.actions.set(processId, []);
                            }
                            var actionIndex = workflowPermissionsDto.actions.get(processId).findIndex(function (value) { return value.id === actionId; });
                            if (actionIndex !== -1) {
                                if (workflowPermissionsDto.actions.get(processId)[actionIndex].categoryPermissionKeys.indexOf(permissionKey) === -1) {
                                    workflowPermissionsDto.actions.get(processId)[actionIndex].categoryPermissionKeys.push(permissionKey);
                                }
                            }
                            else {
                                workflowPermissionsDto.actions.get(processId).push({
                                    id: actionId,
                                    categoryPermissionKeys: [permissionKey]
                                });
                            }
                        }
                    }
                });
            });
            var organizationDto = {
                'organization': organization,
                'addedPermissions': [],
                'removedPermissions': [],
                'addedPoliciesOptions': [],
                'removedPoliciesOptions': [],
                'categoryPermissions': categoryPermissions,
                'workflowPermissionsDto': workflowPermissionsDto,
                'permissionGroupGrantAllDtos': permissionGroupGrantAllDtos
            };
            return _this.organizationService.update(organizationDto);
        }));
    };
    WfPermissionsHelperService.prototype.updateRoleWfPermissions = function (role, processId, actionPermissionKey, wfProcessByAction) {
        var _this = this;
        var actions = {};
        actions[processId] = Array.from(actionPermissionKey.keys())
            .map(function (actionId) { return ({ id: actionId, categoryPermissionKey: actionPermissionKey.get(actionId) }); });
        var roleDto = {
            roleDetail: role,
            addedPermissions: [],
            removedPermissions: [],
            addedPolicies: [],
            removedPolicies: [],
            workflowPermissions: {
                actions: actions,
                processes: []
            },
            categoryPermissionsDtoList: [],
            permissionGroupGrantedOrganizationDtoList: []
        };
        var rolePermissionGroup$ = this.roleService.getPermissionGroupGrantAll(role.id);
        var roleActions$ = this.roleService.getRoleActions(role.id);
        var roleProcesses$ = this.roleService.getRoleProcesses(role.id);
        return Observable_1.Observable.zip(roleActions$, roleProcesses$, rolePermissionGroup$).pipe(operators_1.switchMap(function (data) {
            var roleActions = data[0];
            var roleProcesses = data[1];
            var rolePermissionGroup = data[2];
            roleActions.forEach(function (roleProcessActions, roleProcessId) {
                for (var _i = 0, roleProcessActions_1 = roleProcessActions; _i < roleProcessActions_1.length; _i++) {
                    var roleAction = roleProcessActions_1[_i];
                    if (roleProcessId && roleProcessId !== processId) {
                        actions[roleProcessId] = actions[roleProcessId] || [];
                        actions[roleProcessId].push(roleAction);
                    }
                }
            });
            roleDto.workflowPermissions.actions = actions;
            roleDto.workflowPermissions.processes = roleProcesses;
            roleDto.permissionGroupGrantedOrganizationDtoList = rolePermissionGroup;
            return _this.roleService.update(roleDto);
        }));
    };
    WfPermissionsHelperService.prototype.saveMatrix = function (category, matrix) {
        return this.storageService.put("wf-permissions-matrix-" + category, { value: escape(JSON.stringify(matrix)) });
    };
    WfPermissionsHelperService.prototype.getMatrix = function (category) {
        return this.storageService.get("wf-permissions-matrix-" + category).pipe(operators_1.map(function (response) {
            return JSON.parse(unescape(response['value']));
        }), operators_1.catchError(function (err) {
            if (err.status && err.status === 404) {
                return Observable_1.Observable.of([]);
            }
            return Observable_1.Observable.throw(err);
        }));
    };
    WfPermissionsHelperService.prototype.saveCustomLayoutMetadata = function (category, layoutsMetadata) {
        return this.storageService.put("wf-permissions-layouts-metadata-" + category, { value: JSON.stringify(layoutsMetadata) });
    };
    WfPermissionsHelperService.prototype.getCustomLayoutMetadata = function (category) {
        return this.storageService.get("wf-permissions-layouts-metadata-" + category).pipe(operators_1.map(function (response) {
            return JSON.parse(response['value']);
        }), operators_1.catchError(function (err) {
            if (err.status && err.status === 404) {
                return Observable_1.Observable.of([]);
            }
            return Observable_1.Observable.throw(err);
        }));
    };
    WfPermissionsHelperService.prototype.saveKeysMatrix = function (category, matrix) {
        return this.storageService.put("wf-permissions-keys-matrix-" + category, { value: escape(JSON.stringify(matrix)) });
    };
    WfPermissionsHelperService.prototype.getKeysMatrix = function (category) {
        return this.storageService.get("wf-permissions-keys-matrix-" + category).pipe(operators_1.map(function (response) {
            return JSON.parse(unescape(response['value']));
        }), operators_1.catchError(function (err) {
            if (err.status && err.status === 404) {
                return Observable_1.Observable.of([]);
            }
            return Observable_1.Observable.throw(err);
        }));
    };
    WfPermissionsHelperService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_um_role_client_js_1.RoleService,
            idm_um_organization_client_js_1.OrganizationService,
            idm_um_permission_client_js_1.PermissionConfigurationService,
            storage_service_1.StorageService])
    ], WfPermissionsHelperService);
    return WfPermissionsHelperService;
}());
exports.WfPermissionsHelperService = WfPermissionsHelperService;
//# sourceMappingURL=wf-permissions-helper.service.js.map